"use client";
import React from "react";

const HourOption = ({ setSelectedHour, hideDropdown }) => {
  const hours = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const handleHourSelection = (hour) => {
    setSelectedHour(hour);
    localStorage.setItem("selectedHour", JSON.stringify(hour)); // Set the updated value in localStorage
    hideDropdown();
  };
  return (
    <div className="w-full rounded-lg grid grid-cols-4 text-center">
      {hours.map((hour) => (
        <div
          className="text-lg appearance-none outline-none p-2 hover:text-[#2B3252] cursor-pointer hover:bg-[#F7EFD6] rounded-full"
          key={hour}
          onClick={() => handleHourSelection(hour)}
        >
          {hour}
        </div>
      ))}
    </div>
  );
};
export default HourOption;
